import React, { useState, useEffect } from "react";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { api } from "../../../utils/Api";
import { useParams } from "react-router-dom";

const initial_value = {
  file_path: "",
  total_files: "",
  service_id: "",
};

export default function ModalFilePath(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [is_open, SetIsOpen] = useState(false);
  const [active, SetActive] = useState(true);
  const [add_file, SetAddFile] = useState(false);
  const [file_value, SetFileValue] = useState(initial_value);
  const [id_value, SerIdValue] = useState(useParams());
  const [active_data, SetActiveData] = useState([]);
  const [deleted_data, SetDeletedData] = useState([]);
  const [delete_modal, SetDeleteModal] = useState({
    record: {},
    index: "",
  });

  useEffect(() => {
    console.log("ModalFilePath close data :", close_data);
  }, []);

  useEffect(() => {
    if (props.isOpen) {
      console.log("ModalFilePath On Open :", props);
      SetIsOpen(props.isOpen);
      SetActiveData(props.data.active_data);
      SetDeletedData(props.data.deleted_data);
    }
  }, [props.isOpen]);

  async function addfiles() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: props.data.order_id,
      },
      post: {
        service_id: props.data.service_id,
        total_files: file_value.total_files,
        file_path: file_value.file_path,
      },
    };
    let data = await api("/outlet/add_service_files", pass_data);
    console.log("add_service_files response :", data);
    if (data.status_code == 201) {
      SetActiveData((prevValue) => {
        let push_value = {
          id: data.response.id,
          total_files: file_value.total_files,
          file_path: file_value.file_path,
        };
        prevValue.push(push_value);
        return [...prevValue];
      });
      SetFileValue(initial_value);
      SetAddFile(false);
    }
  }

  async function delete_file(file: any, index: number) {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: props.data.order_id,
      },
      post: {
        service_id: props.data.service_id,
        file_id: file.id,
      },
    };
    let data = await api("/outlet/delete_service_files", pass_data);
    console.log("delete_service_files response :", data);
    if (data.status_code == 200) {
      SetActiveData((prevValue) => {
        prevValue.splice(index, 1);
        return [...prevValue];
      });
      SetDeletedData((prevValue) => {
        prevValue.push(file);
        return [...prevValue];
      });
    }
  }

  return (
    <div>
      <SlidingPane
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        isOpen={is_open}
        title="File Path"
        onRequestClose={() => {
          // triggered on "<" on left top click or on outside click
          let item = close_data;
          item.action = "close";
          SetCloseData(item);
          SetIsOpen(false);
          SetActive(true);
          console.log("close");
          props.close(close_data);
        }}
        from="right"
        width="500px"
      >
        <div className="row">
          <div className="sticky pt-2">
            <div className="row border-bottom w-100">
              <div
                className={
                  active == true
                    ? "col-6 active_filter text-center pb-2"
                    : "col-6 text-center pb-2"
                }
              >
                <p
                  className="cursor text-center  mb-0"
                  onClick={() => {
                    SetActive(true);
                    console.log("Active");
                  }}
                >
                  Active Files
                </p>
              </div>
              <div
                className={
                  active == false
                    ? "col-6 active_filter text-center pb-2"
                    : "col-6 text-center pb-2"
                }
              >
                <p
                  className="cursor text-center  mb-0"
                  onClick={() => {
                    SetActive(false);
                    console.log("Deleted");
                  }}
                >
                  Deleted Files
                </p>
              </div>
            </div>
          </div>

          <div className="p-0">
            {active == true ? (
              <div>
                {add_file == true ? (
                  <div className="row p-2 pt-3 align-content-center add-sticky">
                    <div className="col-10 row">
                      <div className="col-6">
                        <label className="cursor">
                          <p className="form-check-label ">RAW File Path</p>
                          <input
                            className="form-control"
                            type="text"
                            value={file_value.file_path}
                            onChange={(e) => {
                              console.log(
                                "file path on change :",
                                e.target.value
                              );
                              SetFileValue((prevValue) => {
                                prevValue.file_path = e.target.value;
                                return { ...prevValue };
                              });
                            }}
                          />
                        </label>
                      </div>
                      <div className="col-6">
                        <label className="cursor">
                          <p className="form-check-label">Total RAW Files</p>
                          <input
                            className="form-control"
                            type="text"
                            value={file_value.total_files}
                            onChange={(e) => {
                              console.log(
                                "total files on change :",
                                e.target.value
                              );
                              SetFileValue((prevValue) => {
                                prevValue.total_files = e.target.value;
                                return { ...prevValue };
                              });
                            }}
                          />
                        </label>
                      </div>
                    </div>
                    <div className="col-2 ps-0 text-center">
                      <div
                        className="cursor"
                        onClick={() => {
                          SetAddFile(false);
                        }}
                      >
                        <i className="far fa-times-circle"></i>
                      </div>
                      <button
                        className="btn btn-light-outline btn-sm mt-3 w-100"
                        onClick={() => {
                          console.log("add files message:");
                          addfiles();
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                ) : props.order_status_id != "2" ? (
                  <div className="fixed-bottom">
                    <button
                      className="btn btn-light-outline round-btn rounded-circle cursor"
                      onClick={() => {
                        console.log("Add files");
                        SetAddFile(true);
                      }}
                    >
                      <img
                        src={require("../../../assets/icon/svg/plus.svg")}
                        alt=""
                      />
                    </button>
                  </div>
                ) : null}
                {active_data.map((file, f_index) => (
                  <div className="card p-2 m-2" key={f_index}>
                    <div className="row" key={f_index}>
                      <div className="col-10">
                        <div className="d-flex">
                          <p>
                            <b className="text-dark">RAW File Path : </b>
                          </p>
                          <p className="mb-0 ps-2">{file.file_path}</p>
                        </div>

                        <div className="d-flex">
                          <b className="text-dark">Total RAW Files : </b>
                          <p className="mb-0 ps-2">{file.total_files}</p>
                        </div>
                      </div>
                      {props.order_status_id != "2" ? (
                        <div
                          className="col-2 text-center cursor p-0"
                          data-bs-toggle="modal"
                          data-bs-target="#FPDeleteAlertModal"
                          onClick={() => {
                            SetDeleteModal((prevValue: any) => {
                              prevValue.record = file;
                              prevValue.index = f_index;
                              return { ...prevValue };
                            });
                            // delete_file(file, f_index);
                          }}
                        >
                          <img
                            src={require("../../../assets/icon/svg/trash1.svg")}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div>
                {deleted_data.map((file, f_index) => (
                  <div className="card  p-3" key={f_index}>
                    <div className="row p-2" key={f_index}>
                      <div className="col-8 pt-3">
                        <div className="d-flex">
                          <b>File Path : </b>
                          <p className="mb-0 ps-2">{file.file_path}</p>
                        </div>

                        <div className="d-flex">
                          <b>Total Files : </b>
                          <p className="mb-0 ps-2">{file.total_files}</p>
                        </div>
                      </div>
                      <div className="col-4 pt-3">
                        <p>
                          <small>{file.deleted_at}</small>
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </SlidingPane>
      {/* Delete Modal */}
      <div
        className="modal fade"
        id="FPDeleteAlertModal"
        tabIndex={-1}
        aria-labelledby="ModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="  modal-title" id="ModalLabel">
                Delete File Path
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              Are you sure want to delete file path ?
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => {
                  console.log("Delete Confirm");
                  delete_file(delete_modal.record, delete_modal.index);
                }}
              >
                Delete
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
